import CRUDReducer from '../CRUDReducer';
import slideshowActions from '../../actions/fan_feed/fan_feed_slideshow';

const reducer = new CRUDReducer(slideshowActions);

export default (state, action) => reducer.run(state, action);


// WEBPACK FOOTER //
// ./src/reducers/fan_feed/fan_feed_slideshow.ts